import React from 'react';
import PropTypes from 'prop-types';

// Components
import CategoryWidgetList from './CategoryWidgetList';
import RefHeader from './RefHeader';
import NotFound from '../NotFound';

// Presentational Component
const WidgetCategory = ({ categories, widgets, category }) => {
	if (!category) { return <NotFound /> }

	return (
		<div className="widget-category">
			<RefHeader />
			<h2>{category.name} Widgets</h2>
			<p className="summary">{category.summary}</p>
			<CategoryWidgetList categories={categories} widgets={widgets} categoryName={category.name} />
		</div>
	);
};

WidgetCategory.propTypes = {
	categories: PropTypes.object.isRequired,
	widgets: PropTypes.object.isRequired,
	category: PropTypes.object.isRequired
};

export default WidgetCategory;



// WEBPACK FOOTER //
// ./src/components/widgets/WidgetCategory.js